/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Event instance manager
//
// This is the controller to link the EventInstance in-memory model with the page itself.
//
// Expects each item to be in an element with data-instance=true and data-date=start_date
//
// Inside, a click on something with data-action="remove-instance" will remove the instance
// and the associated element
//
// The form used for adding instances is the add_form option.
//   A data-action="add-instance" inside will add an instance
//   Will use data-instance to determine what type of data it is,
//     "start-date" "start-time" or "end-time"
//   Recurrence is supported with
//     "recurrence-ends" "recurrence-type" and "recurrency-day"
//
//   Recurrence types are 'daily', 'weekly', 'monthly'
//   Recurrence days is 0-6 for days of week (can be multiple)
//
//   The other instances should be date inputs
//
// Events will be triggered on the instance container when an instance is added
// or deleted.  The extra parameter for each event is a hash with start_date, start_time,
// end_time.
//   slzr:instance:add => Triggered when an instance is added
//   slzr:instance:remove => Triggered when an instance is removed

import React from 'react';
import ReactDOM from 'react-dom';
import { EventInstances } from '../event_instance_manager/event_instances';
import { EventEmitter } from '../event_emitter';
import { InstanceList } from '../react/instance_list_component.jsx';
import { InstanceManagerComponent } from '../react/instance_manager_component.jsx';

namespace('Slzr.UI', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  const Cls = (exports.EventInstanceManager = class EventInstanceManager extends EventEmitter {
    static initClass() {
      this.prototype.default_options = {
        // Maximum number of instances to allow
        max_instances: 20,
  
        // Maximum date range of recurring instances
        max_range: 366, // 1 year or so
  
        // Initial instances
        //
        // Each element is [start_date, start_time, end_time], should be string values
        initial_instances: [],
  
        // Form controlled by this interface
        form: null
      };
  
      // Flag variable indicating if the instance inputs are dirty
      this.prototype.inputs_changed = true;
  
      // Flag indicating that the form has been validated with a date error
      this.prototype.form_has_date_error = false;
    }

    constructor(options) {
      super();
      this.nextInstance = this.nextInstance.bind(this);
      this.nextInstanceAt = this.nextInstanceAt.bind(this);
      this.nextInstanceDuration = this.nextInstanceDuration.bind(this);
      this.nextInstanceDurationMinutes = this.nextInstanceDurationMinutes.bind(this);
      this._attachEvents = this._attachEvents.bind(this);
      this._initializeUI = this._initializeUI.bind(this);
      this._renderReactComponent = this._renderReactComponent.bind(this);
      this._userChangedInputs = this._userChangedInputs.bind(this);
      this._userAddedInstances = this._userAddedInstances.bind(this);
      this._instanceAdded = this._instanceAdded.bind(this);
      this._instanceRemoved = this._instanceRemoved.bind(this);
this._instanceChanged = this._instanceChanged.bind(this);
      this._dateBecameValid = this._dateBecameValid.bind(this);

      this.options = $.extend({}, this.default_options, options);

      this.form = $(this.options.form);
      this.date_manager_container = this.form.find('[data-instance="manager"]');

      this.instances = new EventInstances({
        max_instances:     this.options.max_instances,
        max_range:         this.options.max_range,
        initial_instances: this.options.initial_instances
      });

      this._attachEvents();
      this._initializeUI();
    }

    // Return the next instance data
    nextInstance() { return this.instances.nextInstance(); }

    // Return the next instance start time
    nextInstanceAt() { return this.instances.nextInstanceAt(); }

    // Return the next instance duration
    nextInstanceDuration() { return this.instances.nextInstanceDuration(); }

    // Return the next instance duration in minutes
    nextInstanceDurationMinutes() { return this.instances.nextInstanceDurationMinutes(); }

    // Attach event handlers to the appropriate events
    _attachEvents() {
      // Trigger instance add when submitting
      this.form.on('submit validation:before', event => {
        if (this.inputs_changed) { this.form.find('[data-action="add-instance"]').prop('disabled', null).trigger('click'); }
        return true;
      });

      // Make sure we have at least one valid date
      this.form.on('validation:complete', (event, data) => {
        if (this.instances.valid()) {
          this.form.find('[data-instance-error="need-date"]').hide();
          this.form_has_date_error = false;
        } else {
          this.form.find('[data-instance-error="need-date"]').show();
          if (data.errors != null) {
            data.errors.push('A valid date must be entered');
          }
          this.form_has_date_error = true;
        }

        // Update the react props; this should only be formHasDateError that changes
        return this._renderReactComponent();
      });

      this.form.on('slzr:date:change', '[data-instance]', () => { return this.inputs_changed = true; });

      this.instances.on('slzr:instance:add', this._instanceAdded);
      this.instances.on('slzr:instance:change', this._instanceChanged);
      return this.instances.on('slzr:instance:remove', this._instanceRemoved);
    }

    /* INSTANCE EVENT HANDLERS */
    // These exist refresh the UI, mainly
    _initializeUI() {
      const my = this;

      // Trigger events for the initial instances being added
      for (const instance of Array.from(this.instances.instances)) { this._instanceAdded(instance); }

      return this._renderReactComponent();
    }

    // Render the react componnent with the latest state
    _renderReactComponent() {
      // isRenderedInAdmin: Difference between admin and user platform
      return ReactDOM.render(React.createElement(InstanceManagerComponent, {
          eventInstances: this.instances,
          onInstancesAdded: this._userAddedInstances,
          onInputChange: this._userChangedInputs,
          onDateBecameValid: this._dateBecameValid,
          isRenderedInAdmin: !this.date_manager_container.data().renderForUser,
          formHasDateError: this.form_has_date_error
        }
        ),
        this.date_manager_container.get(0));
    }

    // Called by the React component when the user enters a valid start
    // date while formHasDateError is true.  Clears the error immediately.
    _dateBecameValid() {
      if (!this.form_has_date_error) { return; }
      this.form_has_date_error = false;
      this.form.find('[data-instance-error="need-date"]').hide();
      this._renderReactComponent();
    }

    // Callbacks regarding form input changes and committing instances
    //
    // This enables automatic commit of instances on form submit, but only if the date inputs have been changed
    _userChangedInputs(event) {
      return this.inputs_changed = true;
    }

    _userAddedInstances(event) {
      return this.inputs_changed = false;
    }

    // Instance event change handlers
    //
    // Just propogate the event through through the form element, as the UI is now handled
    // by InstanceManagerComponent
    _instanceAdded(instance_data) {
      // Propogate the event to anything listening to us
      this.emit('slzr:instance:add', instance_data);
      return this.form.trigger('slzr:instance:add', instance_data);
    }

    _instanceRemoved(instance_data) {
      this.emit('slzr:instance:remove', instance_data);
      return this.form.trigger('slzr:instance:remove', instance_data);
    }

    _instanceChanged(instance_data) {
      this.emit('slzr:instance:change', instance_data);
      return this.form.trigger('slzr:instance:change', instance_data);
    }
  });
  Cls.initClass();


  // Activate instance manager if the page says so
  return $(function() {
    if (!Slzr.Meta['event-is-conference']) {
      const $form = $('form[data-instance="form"]');
      if (!($form.length > 0)) { return; }

      const event_instance_manager = new Slzr.UI.EventInstanceManager({
        form: $form,
        initial_instances: Slzr.Meta['event-instances'] || []});

      return $form[0].event_instance_manager = (top.event_instance_manager = event_instance_manager);
    }
  });
});